import {SetStateAction, useState} from "react";
import {changehue, checkContrast} from "../../../utils/colorcontrast";
import ColorPicker from "../../../components/admin/utilities/ColorPicker";

export function AlertSettingsTab(props: {
    backgroundColor: string,
    setBackgroundColor: SetStateAction<any>,
    fontColor: string,
    setFontColor: SetStateAction<any>,
}) {
    const [passesContrast, setPassesContrast] = useState(checkContrast(props.fontColor, props.backgroundColor));

    function doColorComparison(fontColor, backgroundColor) {
        setPassesContrast(checkContrast(fontColor, backgroundColor));
    }

    function handleDarkenBackground(e) {
        e.preventDefault();
        const newColor = changehue(props.backgroundColor, "darken");
        if (newColor) {
            handleChangeBackground("#" + newColor);
        }
    }

    function handleLightenBackground(e) {
        e.preventDefault();
        const newColor = changehue(props.backgroundColor, "lighten");
        if (newColor) {
            handleChangeBackground("#" + newColor);
        }
    }

    function handleChangeBackground(color) {
        props.setBackgroundColor(color);
        doColorComparison(props.fontColor, color);
    }

    function handleDarkenText(e) {
        e.preventDefault();
        const newColor = changehue(props.fontColor, "darken");
        if (newColor) {
            handleChangeText("#" + newColor);
        }
    }

    function handleLightenText(e) {
        e.preventDefault();
        const newColor = changehue(props.fontColor, "lighten");
        if (newColor) {
            handleChangeText("#" + newColor);
        }
    }

    function handleChangeText(color) {
        props.setFontColor(color);
        doColorComparison(color, props.backgroundColor);
    }

    return <div className="panel panel-default">
        <div className="panel-heading">
            <h3 className="panel-title text-center">Alert Settings</h3>
        </div>
        <div className="panel-body">
            <div className="row">
                <div className="col-lg-3">
                    <label>Background color</label>
                </div>
                <div className="col-lg-4">
                    <ColorPicker picker={"ChromePicker"} color={props.backgroundColor} handleColorChange={handleChangeBackground} />
                    <div style={{float: "right", display: "block"}}>
                        <button onClick={handleLightenBackground} className="alert-bglighten">lighten<span className="hidden"> background</span></button> |
                        <button onClick={handleDarkenBackground} className="alert-bgdarken">darken<span className="hidden"> background</span></button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3">
                    <label>Font color</label>
                </div>
                <div className="col-lg-4">
                    <ColorPicker picker={"ChromePicker"} color={props.fontColor} handleColorChange={handleChangeText} />
                    <div style={{float: "right", display: "block"}}>
                        <button onClick={handleLightenText} className="alert-fglighten">lighten<span className="hidden"> foreground</span></button> |
                        <button onClick={handleDarkenText} className="alert-fgdarken">darken<span className="hidden"> foreground</span></button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-offset-3 col-lg-4 col-xs-12 col-sm-12 sb-alert-contrast-checker-result">
                    <span>Compliance: </span>
                    <span className={passesContrast ? "pass" : "fail"}>{passesContrast ? "Passed" : "Failed"}</span>
                    {passesContrast || <span className="help-block">Lighten or darken to fix.</span>}
                </div>
            </div>
        </div>
    </div>
}
